export default __webpack_public_path__ + "static/media/1.36008b63.png";